import React from 'react'
import _ from 'lodash/fp'
import {getFetcher} from '@startlibs/utils'

let fetchedSuggestions = null

let suggestionsList = []

export const getExistingTags = () => suggestionsList
export const getTagsFromParam = (tagsStr) =>  (tagsStr ? tagsStr.split(",") : []).map(id => getExistingTags().find(({id_tag})=> Number(id)===Number(id_tag))).filter(_.identity)


export const addTagToSuggestions = (tag) => {
  suggestionsList = suggestionsList.filter(({id_tag}) => Number(id_tag) !== Number(tag.id_tag)).concat(tag)
}

export const fetchSuggestions = (allowNew) => (s) => {
  const fetch = fetchedSuggestions || getFetcher("/StudyGetAllTags.php").then(({tags}) => {
    suggestionsList = tags
  })
  fetchedSuggestions = fetch
  return fetch.then(() =>
    suggestionsList.filter(({description}) => description.toLowerCase().indexOf(s) >= 0)
  ).then(l => (l.find(({description}) => description === s) || !allowNew || !s) ? l : l.concat([{newValue: s}]))
}
